import React from "react"
import {
  Eyebrow,
  BreadcrumbContainer,
  Heading,
  ImageWrap,
  ROIHeroImage,
  ROIHeroWrap,
  Subhead,
  TextContent,
} from "./styles/ROIHero.styled"
import Breadcrumbs from "../Hero/components/Breadcrumbs"
import ROICalculator from "."
import BluePattern from "../Hero/assets/blue-pattern.webp"

const ROIHero = ({ detail, openModal, heading, location }) => {
  const isDetail = detail
  const headingText = heading ?? "What is the ROI of a An AI Assistant?"
  const roiSubHeading = "How much time is wasted searching for information or context switching? Imagine if your employees had an AI Assistant that could help guide their attention to what they need to know and do. Calculate the savings"
  const roiDetailSubHeading = "How much time is wasted searching for information or context switching? Imagine if your employees had an AI Assistant that could help find information, perform tasks, and guide their attention to what they need to know and do. Calculate the savings!"
  const descriptionText = isDetail ? roiDetailSubHeading : roiSubHeading; 

  return (
    <ROIHeroWrap>
      <ImageWrap>
        <ROIHeroImage src={BluePattern} loading="lazy" alt="blue-pattern" />
      </ImageWrap>
      <BreadcrumbContainer>
        <Breadcrumbs background="dark" location={location} />
      </BreadcrumbContainer>
      <TextContent>
        <Eyebrow>ROI Calculator</Eyebrow>
        <Heading>{headingText}</Heading>
        <Subhead>
          {descriptionText}
        </Subhead>
      </TextContent>
      <ROICalculator isDetail={isDetail} openModal={openModal} />
    </ROIHeroWrap>
  )
}

export default ROIHero
